import { createFileRoute, redirect } from "@tanstack/react-router";

/** Angular `/settings/workspaces/**` -> `/settings/workspace/**`. */
export const Route = createFileRoute("/_app/settings/workspaces/$")({
	beforeLoad: ({ params }) => {
		const splat = params._splat;
		throw redirect({
			href: splat ? `/settings/workspace/${splat}` : "/settings/workspace",
		});
	},
});
